module.exports = __webpack_public_path__ + "img/mtn.c3f7d87b.svg";